module.exports = __webpack_public_path__ + "img/img.9b8e7c63.png";